import React, { useRef } from "react";
import { PlanEditIcon } from "../../../../../../../../../../utility";
import { OverlayPanel } from "primereact/overlaypanel";
export const LogsAction = ({
  rowData,
  setRowData,
  setIsVoidDialogActive,
  setIsRefundDialogActive,
}) => {
  const op = useRef(null);
  return (
    <div className="flex flex-wrap flex-row justify-content-end  w-full h-full align-items-center main-action-wrapper actionbtnmain">
      <div
        className="flex flex-wrap flex-row justify-content-end  w-full h-full align-items-center main-action-wrapper actionbtnmain"
        onClick={(e) => {
          e.stopPropagation();
          op.current.toggle(e);
          setRowData(rowData);
        }}
      >
        <PlanEditIcon />
      </div>
      <OverlayPanel
        ref={op}
        style={{ width: "10.9rem", height: "8rem" }}
        className="flex align-items-center billingconfig"
      >
        <div className="flex flex-column w-full overlay">
          <div
            className="flex justify-content-start align-items-center prospectoverlay"
            style={{
              height: "3.2rem",
              width: "10.7rem",
              paddingLeft: "1.2rem",
            }}
            onClick={() => {
              setRowData(rowData);
              setIsVoidDialogActive(true);
            }}
          >
            <label style={{ fontSize: "1.2rem", fontWeight: "500" }}>
              Void
            </label>
          </div>
          <div
            className={`flex justify-content-start align-items-center prospectoverlay ${
              rowData?.paymentStatus === "failure" || rowData?.isRefund
                ? "disabled-action"
                : ""
            }`}
            style={{
              height: "3.2rem",
              width: "10.7rem",
              paddingLeft: "1.2rem",
              opacity:
                rowData?.paymentStatus === "failure" || rowData?.isRefund
                  ? 0.4
                  : 1,
              cursor:
                rowData?.paymentStatus === "failure" || rowData?.isRefund
                  ? "not-allowed"
                  : "pointer",
            }}
            onClick={() => {
              if (rowData?.paymentStatus === "failure" || rowData?.isRefund) {
                return;
              }
              setRowData(rowData);
              setIsRefundDialogActive(true);
            }}
          >
            <label style={{ fontSize: "1.2rem", fontWeight: "500" }}>
              Refund
            </label>
          </div>
        </div>
      </OverlayPanel>
    </div>
  );
};
